import React, { useState } from "react";
import styled from "styled-components";

import colors from "shared/styles/colors";

interface IBasedOnTemplateWarningProps {
    deviated: boolean;
}

const BasedOnTemplateWarning: React.FC<IBasedOnTemplateWarningProps> = ({ deviated }) => {
    const [open, setOpen] = useState(true);

    if (!open) {
        return null;
    }

    const deviatedStateText = deviated ? 'This process is diverged from the template.' : 'This process will be diverged from the template on save.'

    return (
        <StyledBasedOnTemplateWarning>
            <p>
                Editing a template based Process. {deviatedStateText}
            </p>

            <button
                title="Close"
                onClick={() => setOpen(false)}
            >
                <i className="ci-close_big pointer" />
            </button>
        </StyledBasedOnTemplateWarning>
    );
};

export default BasedOnTemplateWarning;

const StyledBasedOnTemplateWarning = styled.div`
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 3;
    padding: 6px 6px 8px 14px;
    display: flex;
    gap: 10px;
    align-items: center;
    border-radius: 2px;
    border: 1px solid ${colors.yellow2};;
    background: ${colors.yellow3};

    p {
        margin: 0;
        font-size: 14px;
        color: ${colors.yellow1};
    }

    button {
        all: unset;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        aspect-ratio: 1;
        
        i {
            color: ${colors.grey_1};
        }
    }
`;